import React from 'react';
import { Component, Container } from "puzzle";
import classNames from "classnames";

type PROPS = {
  label: string,
  className?: string,
  ref?: any
};

type STATE = {};

class PreferencesCard extends Component<PROPS, STATE> {

  render() {
    const {label, children, className } = this.props;
    let sectionCssClass= classNames('tp-section-container tp-100', {[className]: className});

    return (
      <Container
        ariaLabel={`${label}`}
        className={sectionCssClass}
        htmlTag={'section'}
        tabIndex={0}
      >
        <Container className={'tp-section-shadow'}>
          <Container className="tp-section-container-content" vBox gap={6}>
            <Container
              htmlTag={'h3'}
              hBox
              alignItemsCenter
              justifyContentBetween
              className="tp-section-container-title tp-font-size-md"
            >
              {label}
            </Container>
            <div className="tp-section-container-content-inner-wrap">{children}</div>
          </Container>
        </Container>
      </Container>
    );
  }
}

export default PreferencesCard;
